import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { SUPPORTED_LOCALES, LOCALE_DIRECTION_MAP } from './localeConfig';

// English (reference locale)
import commonEn from './locales/en/common.json';
import navigationEn from './locales/en/navigation.json';
import profileEn from './locales/en/profile.json';
import assignmentsEn from './locales/en/assignments.json';
import formsEn from './locales/en/forms.json';
import notificationsEn from './locales/en/notifications.json';

// Spanish
import commonEs from './locales/es/common.json';
import navigationEs from './locales/es/navigation.json';
import profileEs from './locales/es/profile.json';
import assignmentsEs from './locales/es/assignments.json';
import formsEs from './locales/es/forms.json';
import notificationsEs from './locales/es/notifications.json';

// German
import commonDe from './locales/de/common.json';
import navigationDe from './locales/de/navigation.json';
import profileDe from './locales/de/profile.json';
import assignmentsDe from './locales/de/assignments.json';
import formsDe from './locales/de/forms.json';
import notificationsDe from './locales/de/notifications.json';

// French
import commonFr from './locales/fr/common.json';
import navigationFr from './locales/fr/navigation.json';
import profileFr from './locales/fr/profile.json';
import assignmentsFr from './locales/fr/assignments.json';
import formsFr from './locales/fr/forms.json';
import notificationsFr from './locales/fr/notifications.json';

// Dutch
import commonNl from './locales/nl/common.json';
import navigationNl from './locales/nl/navigation.json';
import profileNl from './locales/nl/profile.json';
import assignmentsNl from './locales/nl/assignments.json';
import formsNl from './locales/nl/forms.json';
import notificationsNl from './locales/nl/notifications.json';

// Swedish
import commonSv from './locales/sv/common.json';
import navigationSv from './locales/sv/navigation.json';
import profileSv from './locales/sv/profile.json';
import assignmentsSv from './locales/sv/assignments.json';
import formsSv from './locales/sv/forms.json';
import notificationsSv from './locales/sv/notifications.json';

// Norwegian
import commonNo from './locales/no/common.json';
import navigationNo from './locales/no/navigation.json';
import profileNo from './locales/no/profile.json';
import assignmentsNo from './locales/no/assignments.json';
import formsNo from './locales/no/forms.json';
import notificationsNo from './locales/no/notifications.json';

// Danish
import commonDa from './locales/da/common.json';
import navigationDa from './locales/da/navigation.json';
import profileDa from './locales/da/profile.json';
import assignmentsDa from './locales/da/assignments.json';
import formsDa from './locales/da/forms.json';
import notificationsDa from './locales/da/notifications.json';

// Finnish
import commonFi from './locales/fi/common.json';
import navigationFi from './locales/fi/navigation.json';
import profileFi from './locales/fi/profile.json';
import assignmentsFi from './locales/fi/assignments.json';
import formsFi from './locales/fi/forms.json';
import notificationsFi from './locales/fi/notifications.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: commonEn,
        navigation: navigationEn,
        profile: profileEn,
        assignments: assignmentsEn,
        forms: formsEn,
        notifications: notificationsEn,
      },
      es: {
        common: commonEs,
        navigation: navigationEs,
        profile: profileEs,
        assignments: assignmentsEs,
        forms: formsEs,
        notifications: notificationsEs,
      },
      de: {
        common: commonDe,
        navigation: navigationDe,
        profile: profileDe,
        assignments: assignmentsDe,
        forms: formsDe,
        notifications: notificationsDe,
      },
      fr: {
        common: commonFr,
        navigation: navigationFr,
        profile: profileFr,
        assignments: assignmentsFr,
        forms: formsFr,
        notifications: notificationsFr,
      },
      nl: {
        common: commonNl,
        navigation: navigationNl,
        profile: profileNl,
        assignments: assignmentsNl,
        forms: formsNl,
        notifications: notificationsNl,
      },
      sv: {
        common: commonSv,
        navigation: navigationSv,
        profile: profileSv,
        assignments: assignmentsSv,
        forms: formsSv,
        notifications: notificationsSv,
      },
      no: {
        common: commonNo,
        navigation: navigationNo,
        profile: profileNo,
        assignments: assignmentsNo,
        forms: formsNo,
        notifications: notificationsNo,
      },
      da: {
        common: commonDa,
        navigation: navigationDa,
        profile: profileDa,
        assignments: assignmentsDa,
        forms: formsDa,
        notifications: notificationsDa,
      },
      fi: {
        common: commonFi,
        navigation: navigationFi,
        profile: profileFi,
        assignments: assignmentsFi,
        forms: formsFi,
        notifications: notificationsFi,
      },
    },
    fallbackLng: 'en',
    defaultNS: 'common',
    supportedLngs: SUPPORTED_LOCALES,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
  });

// Listener para actualizar dir y lang del HTML raíz al cambiar idioma
i18n.on('languageChanged', (lng) => {
  const dir = LOCALE_DIRECTION_MAP[lng] || 'ltr';
  document.documentElement.setAttribute('dir', dir);
  document.documentElement.setAttribute('lang', lng);
});

export default i18n;
